import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const SyriatelSyriaIntegrationMixin = {
  extends: BaseIntegration,
};

export default SyriatelSyriaIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/syriatelSyriaIntegration.js